    <div class="modal-content">
        <div class="modal-header">
            <h3 class="modal-title pull-left ">Bid History</h3>
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeBidHistoryDialog()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row symetricMargin">
                <p class="sub-title">Sale #
                    : <span class="normalWeight">{{bidhistoryList[0]?.SaleNo}}</span>
                </p>
                <p class="sub-title">VIN
                    : <span class="normalWeight">{{bidhistoryList[0]?.Vin}}</span>
                </p>
                <p class="sub-title">Make
                    : <span class="normalWeight">{{bidhistoryList[0]?.MakeName}}</span>
                </p>
                <p class="sub-title">Model
                    : <span class="normalWeight">{{bidhistoryList[0]?.ModelName}}</span>
                </p>
            </div>
            <div class="">
                <table class="table table-bordered mb-0 text-nowrap" align="center">
                    <thead>
                        <tr class="bg-primary">
                            <th scope="col">Bidding Date</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Max Bid</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let tl of bidhistoryList">
                            <td class="tbl" data-label="Bidding Date">{{tl.BiddingDate | date:'MMM d, y, h:mm a'}}</td>
                            <td class="tbr" data-label="Amount">{{tl.Amount| currency: 'USD'}}</td>
                            <td class="tbr" data-label="Amount">{{tl.MaxBid| currency: 'USD'}}</td>
                        </tr>
                        <tr *ngIf="bidhistoryList?.length == 0">
                            <td colspan="6">
                                <p class="text-left">No Records Found</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
